var exports = {
  "kL": "x127c5a35--68a221--container",
  "nM": "x127c5a35--68a221--row",
  "kv": "x127c5a35--68a221--checkbox",
  "Im": "x127c5a35--68a221--comment",
  "Sl": "x127c5a35--68a221--image",
  "EC": "x127c5a35--68a221--main_content",
  "MA": "x127c5a35--68a221--agent",
  "pq": "x127c5a35--68a221--info",
  "nT": "x127c5a35--68a221--info_top",
  "ru": "x127c5a35--68a221--geo_info",
  "h_": "x127c5a35--68a221--description",
  "BT": "x127c5a35--68a221--description--no-gradient",
  "e8": "x127c5a35--68a221--description-with-areaParts",
  "xQ": "x127c5a35--68a221--hide_print",
};

module.exports = exports;
